import { createContext } from 'react';
/*
  accessToken
  scope,
  isAuthenticated,
  meta,

  onAuthenticated,
  oauthOptions,

  authenticate,
  handleLogout,
  registerOnAuthenticate,
  registerOnLogout,
 */

var context = /*#__PURE__*/createContext(null);
export default context;